module.exports = __webpack_public_path__ + "Roboto-Thin.1f35e6a11d27d2e10d28.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/yoann/Perso/Pedicure-Podologue/~/materialize-css/dist/fonts/roboto/Roboto-Thin.woff2
// module id = ../../../../materialize-css/dist/fonts/roboto/Roboto-Thin.woff2
// module chunks = 2